import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

import founderImg from '../assets/newHeader/founder-image.png';
import image18 from '../assets/newHeader/img18.jpeg';
import image1 from '../assets/newHeader/img26.jpeg';
import image2 from '../assets/newHeader/img27.jpeg';
import image3 from '../assets/newHeader/img28.jpeg';
import jobImg1 from '../assets/newHeader/jobImg1.svg';
import jobImg2 from '../assets/newHeader/jobImg2.svg';
import jobImg3 from '../assets/newHeader/jobImg3.svg';
import jobImg4 from '../assets/newHeader/jobImg4.svg';
import jobImg5 from '../assets/newHeader/jobImg5.svg';
import { ReactComponent as image8 } from '../assets/newHeader/svg10.svg';
import { ReactComponent as image5 } from '../assets/newHeader/svg11.svg';
import { ReactComponent as image6 } from '../assets/newHeader/svg12.svg';
import { ReactComponent as image7 } from '../assets/newHeader/svg13.svg';
import { ReactComponent as Image9 } from '../assets/newHeader/svg14.svg';
import wwsImg1 from '../assets/newHeader/wwsImg1.svg';
import wwsImg2 from '../assets/newHeader/wwsImg2.svg';
import wwsImg3 from '../assets/newHeader/wwsImg3.svg';
import wwsImg4 from '../assets/newHeader/wwsImg4.svg';
import forEmp from '../assets/public-site/forEmp.png';
import connectingLine from '../assets/public-site/hiw-connectingLine.svg';
import image16 from '../assets/public-site/img16.jpeg';
import image4 from '../assets/public-site/img4.png';
import { ReactComponent as SurfaceIcon } from '../assets/public-site/svg15.svg';
import { ReactComponent as MatchIcon } from '../assets/public-site/svg16.svg';
import { ReactComponent as PlaceIcon } from '../assets/public-site/svg17.svg';
import { FeatureCard } from '../components/common/FeatureCard';
// import { InfoCard } from '../components/common/InfoCard';
// eslint-disable-next-line import/order
import { TestimonialCarousel } from '../components/common/TestimonialCarousel';
import { TrustedBrands } from '../components/common/TrustedBrands';
import { VovationalPage } from '../components/common/VovationalPage';
import { ExportedIcon, VlLockIcon } from '../components/icons/icons';
import { NewFooter } from '../components/Layout/NewFooter';
import { NewNavbar } from '../components/Layout/NewHeader';

import { ConnectForm } from './ConnectUseForm';

export const HomePage: React.FC = () => {
  const [expandedSecondCard, setExpandedSecondCard] = useState<string | null>(null);
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  const handleSecondCardClick = (cardKey: string) => {
    setExpandedSecondCard((prev) => (prev === cardKey ? null : cardKey));
  };

  const features = [
    {
      image: image1,
      title: 'Predictive Matching',
      description:
        'Match overlooked candidates to roles where they’ll thrive—based on skills, motivation, and potential, not just past job titles.',
    },
    {
      image: image2,
      title: 'Prescriptive Workflows',
      description:
        'Don’t just track problems—solve them. Vero guides what to do next (e.g., “Retrain this team in 120 days”).',
    },
    {
      image: image3,
      title: 'Integrated Intelligence',
      description:
        'Vero connects across your existing tools—layering predictive insight into hiring, placement, and retention workflows.',
    },
  ];
  const jobFirst = [
    {
      svg: jobImg1,
      title: 'Real-world experience, skills development, and natural competencies',
    },

    {
      svg: jobImg3,
      title: 'Outcome data across hiring, retention, and internal mobility',
    },
    {
      svg: jobImg2,
      title: 'Feedback loops from hiring managers and workforce partners',
    },
  ];
  const jobSecond = [
    {
      svg: jobImg4,
      title: 'Motivation you can measure—and activate.',
      description:
        'Most platforms assess skills. Vero goes further by identifying what drives someone to succeed - and builds personalized plans from day one. Our pre-employment screening doesn’t just test aptitude, it lights the spark that drives long-term performance.',
      bullets: [
        '87%+ completion rate across 35,000+ users',
        'Builds custom talent pathways based on readiness, preferences, and strengths',
        'Turns potential into action with day-one clarity and commitment',
      ],
    },
    {
      svg: jobImg5,
      title: 'Smarter with scale — not just bigger.',
      description:
        'With each placement, Vero’s AI learns which traits predict success - and sharpens future matches accordingly. Unlike static tools, our system improves over time, delivering faster, smarter, and more predictive hiring outcomes.',
      bullets: [
        'Feedback loops from managers and clients refine match logic',
        'Real-world data trains the system to minimize churn and boost retention',
        'Long-term performance fuels better shortlists and candidate rankings',
      ],
    },
  ];

  const cardsData = [
    {
      svg: image8,
      title: 'Spot potential others miss',
    },
    {
      svg: image5,
      title: 'Predict high-performers before the interview',
    },
    {
      svg: image6,
      title: 'Align roles, readiness, and retention across your teams',
    },
    {
      svg: image7,
      title: 'Build a pipeline of future leaders from day one',
    },
  ];

  const testimonialData = [
    {
      name: 'Edwin Rivera',
      location: 'Managing Partner, CG1 Solutions',
      title: 'Faster Hires, Better Matches',
      text: 'Vero helped us reduce time-to-hire by over 60% while improving placement fit. Their team gets it.',
      image: image16,
    },
  ];
  return (
    <>
      {/* Header */}
      <NewNavbar />

      {/* Hero Banner Section */}
      <section className="h-screen relative flex items-end before:bg-gradient-to-r before:from-[#000000] before:to-transparent before:absolute before:inset-0 before:z-10">
        {/* Background Video */}
        <video
          autoPlay
          loop
          muted
          playsInline
          className="absolute top-0 left-0 w-full h-full object-cover z-0"
        >
          <source
            src="https://vero-learning-course-videos.s3.us-east-2.amazonaws.com/other/headers.mp4"
            type="video/mp4"
          />
          Your browser does not support the video tag.
        </video>

        {/* Foreground Content */}
        <div className="container px-4">
          <div className="relative z-20 flex flex-col justify-center gap-4 items-start h-full text-white mb-16 max-w-2xl">
            <h1 className="text-3xl sm:text-4xl md:text-5xl font-normal leading-snug sm:leading-tight">
              Hire better from the{' '}
              <span className="text-secondary-500 font-extrabold">talent others miss.</span>
            </h1>

            <p className="text-base sm:text-lg md:text-xl !leading-relaxed">
              Vero is the infrastructure for predictive, equitable hiring and long-term
              retention—helping employers place and retain nontraditional talent by knowing who will
              succeed, where they'll thrive, and how to support their path to leadership from day
              one.
            </p>

            <a
              href="https://meetings.hubspot.com/chrissybil/vero-learning"
              className="btn btn-primary !py-4 !px-6 sm:!py-5 sm:!px-8 md:!py-6 md:!px-9 hover:underline"
              target="_blank"
            >
              Schedule a Demo <ExportedIcon />
            </a>
          </div>
        </div>

        {/* Optional Scroll Button (uncomment if needed) */}
        {/* <div className="btn btn-secondary text-lgabsolute -bottom-14 left-1/2 transform -translate-x-1/2 z-20 w-20 h-28 !p-0 !rounded-full">
    <ArrowDownIcon style={{ width: 40 }} />
  </div> */}
      </section>

      {/* Trusted by employers, cities, and changemakers shaping the future of work. section */}
      <TrustedBrands />

      <section className="pt-16">
        <div className="container text-center">
          <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-light leading-tight mb-5">
            Built for What’s
            <span className="font-bold text-primary-500"> Next in Hiring</span>
          </h2>

          <div className="border-t border-b border-[#E0E4FF] px-5 py-8 mx-4">
            <p className="text-base sm:text-lg md:text-3xl !leading-relaxed">
              Vero is the predictive infrastructure powering equitable hiring, smarter placement,
              and long-term retention—especially for the talent others miss.
            </p>
          </div>
        </div>
      </section>

      {/* Meet the Invisible Majority Section */}
      <section className="py-16">
        <div className="container px-4">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
            {/* Left Content */}
            <div>
              <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-light mb-4 !leading-tight">
                Meet the
                <span className="font-bold text-primary-500"> Invisible Majority</span>
              </h2>

              <p className="text-xl sm:text-lg md:text-xl leading-loose">
                Also known as nontraditional talent—people who are full of potential, even if it
                doesn’t show up on a resume.
              </p>

              <p className="text-xl sm:text-lg md:text-xl font-bold leading-loose mt-4">
                Vero identifies:
              </p>

              <ul className="list-disc pl-5 text-xl sm:text-lg md:text-xl !leading-loose mt-2">
                <li>Workers without college degrees</li>
                <li>Career gaps, reentry talent, veterans, first-gen professionals</li>
                <li>Anyone whose experience doesn’t show up on paper</li>
              </ul>

              <p className="text-base sm:text-lg md:text-xl leading-loose mt-4">
                This is the invisible majority of the workforce—often overlooked, but full of
                potential. We help you find, place, and retain them.
              </p>
            </div>

            {/* Right Image */}
            <div className="relative w-full">
              <img
                src={image4}
                alt="Team Collaboration"
                className="w-full h-auto object-cover rounded-xl"
              />
            </div>
          </div>
        </div>
      </section>

      {/* The Future We’re Building Section */}
      <section className="py-16">
        <div className="container px-4 grid grid-cols-1 lg:grid-cols-2 items-center gap-12">
          {/* Text Content */}
          <div className="space-y-6">
            <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl !leading-tight">
              The Future <span className="text-primary-500 font-bold">We’re Building</span>
            </h2>

            <p className="text-xl sm:text-lg md:text-xl !leading-loose">
              Vero is building the predictive infrastructure for hiring overlooked talent-at scale.
              <br /> <br />
              We believe the future of hiring must be predictive, equitable, and grounded in
              potential-not pedigree. Vero is more than a tool. It's the infrastructure for upward
              mobility-built to help employers grow smarter and unlock new paths for untapped
              talent. We don’t stop at match. We prescribe what’s next-so every decision moves
              people forward.
            </p>

            <p className="text-lg sm:text-xl ">Act on potential. Measure real success.</p>

            <p className="text-2xl sm:text-2xl md:text-3xl font-bold">
              Let’s shape the future of work together.
            </p>

            <a
              href="https://meetings.hubspot.com/chrissybil/vero-learning"
              className="btn btn-secondary hover:underline inline-flex items-center gap-2"
              target="_blank"
            >
              Schedule a strategy session <ExportedIcon />
            </a>
          </div>

          {/* Visual Cards Grid */}
          <div className="grid grid-cols-1 sm:grid-cols-2 grid-rows-2 max-w-2xl mx-auto w-full">
            <div className="rounded-tl-[60px] overflow-hidden h-80 ">
              <img src={image18} alt="Team working" className="w-full h-full object-cover" />
            </div>

            <div className="bg-cream-200 p-6 rounded-tr-[60px] rounded-bl-[120px] flex flex-col justify-center text-center h-80 ">
              <p>Screening Completion</p>
              <h3 className="text-3xl sm:text-4xl font-bold">87%</h3>
              <p className="text-gray-600 mt-2 text-sm sm:text-base">
                High engagement with pre-hire experience signals
              </p>
            </div>

            <div className="bg-green-200 p-6 rounded-bl-[60px] rounded-tr-[120px] flex items-start h-80 ">
              <div className="space-y-3 py-12">
                {[
                  'Faster time-to-hire',
                  'Trusted across retail, healthcare, and logistics',
                  'Loved by talent teams solving real hiring pain',
                ].map((tag, i) => (
                  <div
                    key={i}
                    className="rounded-full px-4 py-2 text-sm border border-black inline-flex gap-2 items-center"
                  >
                    <span>{tag}</span>
                    <ExportedIcon style={{ flexShrink: 0 }} />
                  </div>
                ))}
              </div>
            </div>

            <div className="bg-primary-200 p-6 rounded-br-[60px] flex flex-col justify-center text-center h-80 ">
              <p>Users on the platform</p>
              <h3 className="text-3xl sm:text-4xl font-bold">35,000+</h3>
              <p className="text-gray-600 mt-2 text-sm sm:text-base">
                Empowering employers, orgs & candidates nationwide
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* What Makes Section*/}
      <section className="pt-16">
        <div className="container px-4">
          <h2 className="text-3xl sm:text-4xl md:text-5xl text-center font-normal mb-8 leading-snug">
            What Makes <span className="text-primary-500 font-bold">Vero Different</span>
          </h2>
          <p className="text-3xl text-center mb-8">
            Traditional systems track resumes. We predict performance.
          </p>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 place-items-stretch">
            {features.map((feature, index) => (
              <FeatureCard
                key={index}
                image={feature.image}
                title={feature.title}
                description={feature.description}
              />
            ))}
          </div>

          <div className="py-8 mt-8 border-t border-gray-200">
            <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-4">
              <h2 className="text-lg sm:text-2xl ">
                Backed by 35,000+ users, enterprise-grade security, and built to plug into your
                stack.
              </h2>

              <VlLockIcon />
            </div>
          </div>
        </div>
      </section>

      {/* Want to see how it works? section */}
      <section className="py-8 bg-green-200">
        <div className="container px-4">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4 text-center md:text-left">
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-semibold mb-4">
              Want to see how it works?
            </h2>
            <a
              href="https://meetings.hubspot.com/chrissybil/vero-learning"
              className="btn btn-secondary !text-lg hover:underline inline-flex items-center gap-2"
              target="_blank"
              rel="noopener noreferrer"
            >
              See Vero in action <ExportedIcon />
            </a>
          </div>
        </div>
      </section>

      {/* How Vero Predicts Job Success Section */}
      <section className="py-16 bg-primary-200">
        <div className="container px-4">
          <h2 className="text-4xl sm:text-5xl md:text-6xl font-light mb-4 !leading-tight text-center">
            How Vero Forecasts
            <span className="font-bold text-primary-500"> Job Success</span>
          </h2>
          <p className="text-xl sm:text-2xl text-center mb-6">
            Forget static resumes. Vero forecasts fit using the signals that actually matter.
          </p>

          {/* Job First Cards */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {jobFirst.map((card, idx) => (
              <div
                key={idx}
                className="bg-white rounded-[40px] overflow-hidden relative p-8 shadow-lg hover:shadow-xl transition-all"
              >
                {card.svg && <img src={card.svg} alt={card.title} className="h-56 mx-auto" />}
                <div className="mt-5">
                  <p className="text-center text-lg">{card.title}</p>
                </div>
              </div>
            ))}
          </div>

          {/* Job Second Cards */}
          <div className={`grid grid-cols-1 lg:grid-cols-2 gap-6 mt-6`}>
            {jobSecond.map((card, idx) => {
              const cardKey = `second-${idx}`;
              return (
                <div
                  key={cardKey}
                  onClick={() => handleSecondCardClick(cardKey)}
                  className={`bg-white rounded-[40px] overflow-hidden relative h-auto p-8 border border-purple-200 shadow-lg hover:shadow-xl transition-all cursor-pointer ${
                    expandedSecondCard === cardKey ? 'lg:h-auto' : 'lg:h-[355px]'
                  }`}
                >
                  {card.svg && <img src={card.svg} alt={card.title} className="mx-auto" />}
                  <div className="mt-5">
                    <p className="text-2xl text-center font-bold">{card.title}</p>

                    {expandedSecondCard === cardKey ? (
                      <>
                        <p className="text-center text-lg text-gray-700 mt-3">{card.description}</p>
                        <ul className="mt-3 list-disc list-inside text-center text-gray-700 text-base">
                          {card.bullets.map((bullet, bulletIdx) => (
                            <li key={bulletIdx}>{bullet}</li>
                          ))}
                        </ul>
                      </>
                    ) : null}
                  </div>
                </div>
              );
            })}
          </div>

          <p className="text-2xl mt-8">
            Trusted by ASA, Office Depot, and 35,000+ users with 87% screening completion.
          </p>
        </div>
      </section>

      {/* For Employers Who Look Beyond the Hire Section */}
      <section className="py-16">
        <div className="container px-4">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
            {/* Left Content */}
            <div>
              <h2 className="text-4xl sm:text-5xl md:text-6xl font-light mb-4 !leading-tight">
                For Employers Who Look
                <span className="font-bold text-primary-500"> Beyond the Hire</span>
              </h2>
              <p className="text-xl sm:text-2xl !leading-loose mb-8">
                Vero is the infrastructure for post-hire success—helping you place and grow emerging
                talent, from day one to promotion.
              </p>
              <a
                className="btn btn-secondary !text-lg hover:underline"
                href="https://meetings.hubspot.com/chrissybil/vero-learning"
                target="_blank"
                rel="noopener noreferrer"
              >
                See how we partner <ExportedIcon />
              </a>
            </div>

            {/* Right Content (Image) */}
            <div className="relative w-full">
              <img
                src={forEmp}
                alt="For Employers Who Look Beyond the Hire"
                className="w-full h-auto"
                loading="lazy" // Added lazy loading for better performance
              />
            </div>
          </div>
        </div>
      </section>

      {/* Connect with Us Section */}
      <section className="pb-16">
        <div className="container">
          <p className="text-2xl text-center mb-4">Who We Support</p>
          <h2 className="text-4xl sm:text-5xl md:text-6xl text-center mb-8">
            Built for those who don’t just hire
            <span className="text-primary-500 font-bold">-but shape what’s possible.</span>
          </h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
            {/* Employer Card 1 */}
            <div className="col-span-1 px-6 py-12 rounded-[40px] bg-primary-200 flex flex-col items-center gap-5">
              <div className="h-56">
                <img
                  src={wwsImg1}
                  alt="For Employers Who Look Beyond the Hire"
                  className="w-full h-auto"
                  loading="lazy" // Added lazy loading for better performance
                />
              </div>
              <p className=" text-xl text-center !leading-loose">
                For employers done losing top talent to guesswork
              </p>
            </div>
            {/* Employer Card 2 */}
            <div className="col-span-1 px-6 py-12 rounded-[40px] bg-green-200 flex flex-col items-center gap-5">
              <div className="h-56">
                <img
                  src={wwsImg2}
                  alt="For Employers Who Look Beyond the Hire"
                  className="w-full h-auto"
                  loading="lazy" // Added lazy loading for better performance
                />
              </div>
              <p className=" text-xl text-center !leading-loose">
                For HR leaders and hiring teams who want to reduce churn and build future leaders
              </p>
            </div>
            {/* Employer Card 3 */}
            <div className="col-span-1 px-6 py-12 rounded-[40px] bg-cream-200 flex flex-col items-center gap-5">
              <div className="h-56">
                <img
                  src={wwsImg3}
                  alt="For Employers Who Look Beyond the Hire"
                  className="w-full h-auto"
                  loading="lazy" // Added lazy loading for better performance
                />
              </div>
              <p className=" text-xl text-center !leading-loose">
                For workforce partners who need to prove outcomes beyond placement
              </p>
            </div>
            {/* Employer Card 4 */}
            <div className="col-span-1 px-6 py-12 rounded-[40px] bg-secondary-200 flex flex-col items-center gap-5">
              <div className="h-56">
                <img
                  src={wwsImg4}
                  alt="For Employers Who Look Beyond the Hire"
                  className="w-full h-auto"
                  loading="lazy" // Added lazy loading for better performance
                />
              </div>
              <p className=" text-xl text-center !leading-loose">
                For systems builders solving real-world hiring equity and retention challenges
              </p>
            </div>
          </div>

          {/* Button Section */}

          <div className="flex flex-col sm:flex-row gap-4 items-center justify-between mt-12">
            <p className="text-3xl font-bold">Ready to see the potential others miss?</p>
            <a
              className="btn btn-secondary !text-lg"
              text-lg
              href="https://meetings.hubspot.com/chrissybil/vero-learning"
              target="_blank"
            >
              Schedule a strategy session <ExportedIcon />
            </a>
          </div>
        </div>
      </section>

      {/* Employers Section */}
      <section className="bg-primary-200 py-16">
        <div className="container">
          <div className="flex flex-col gap-5 text-center mb-8">
            <p className="text-2xl ">Who We Serve</p>
            <h2 className="text-5xl sm:text-6xl font-bold mb-2">
              <span className="text-primary-500">Employers</span>
            </h2>

            <h3 className="text-2xl font-light">
              Smarter hiring. Stronger retention. Predictive fit.
            </h3>
            <p className="mb-6 text-xl !leading-relaxed">
              Vero helps HR leaders and staffing teams uncover overlooked talent, match them where
              they’ll thrive, and grow them into tomorrow’s leaders—especially in frontline
              industries like retail, healthcare, logistics, and manufacturing where churn is high
              and growth is critical.
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {cardsData.map((card, idx) => (
              <div
                key={idx}
                className="bg-white rounded-[40px] overflow-hidden relative p-6 border border-dashed border-primary-500"
              >
                {card.svg && <card.svg className="w-full h-56 object-cover" />}
                <div className="mt-2">
                  <p className="text-xl text-center font-semibold">{card.title}</p>
                </div>
              </div>
            ))}
          </div>

          <div className="mt-8">
            {/* Left: Text Content */}
            <p className="text-xl mb-3 ">
              Vero is the infrastructure for post-hire success-helping you place emerging talent
              where they’ll thrive and unlocking upward mobility from day one.
            </p>

            <a
              href="https://meetings.hubspot.com/chrissybil/vero-learning"
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn-secondary !text-lg"
              text-lg
            >
              See how we partner <ExportedIcon style={{ fontSize: 20 }} />
            </a>
          </div>
        </div>
      </section>

      {/* Workforce Organization Section */}
      <section className="py-16 pt-20">
        <div className="container">
          <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-light !leading-snug mb-5">
            <span className="font-bold">Workforce Organization</span>
            <br />
            From intake to upward mobility—prove your{' '}
            <span className="text-primary-500 font-bold">impact at every step.</span>
          </h2>
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 items-center">
            <div>
              <p className="text-base sm:text-xl !leading-loose">
                Vero supports workforce boards, cities, and nonprofits that do more than deliver
                training—they connect people to real opportunity. We help you match talent to jobs,
                track long-term success, and show funders what’s working.
              </p>

              <ul className="list-disc list-inside text-left !leading-loose text-base sm:text-lg md:text-xl mt-4">
                <li>
                  <strong>Recommend</strong> career-aligned jobs and industries
                </li>
                <li>
                  <strong>Match</strong> participant skills to real employer demand
                </li>
                <li>
                  <strong>Automate</strong> job matching at scale using real-world experience,
                  natural competencies, and readiness data
                </li>
                <li>
                  <strong>Track</strong> retention and long-term mobility—not just job placement
                </li>
                <li>
                  <strong>Integrate</strong> seamlessly with CRMs and case management systems
                </li>
              </ul>
            </div>
            <div>
              <Image9 className="w-full h-auto object-cover rounded-lg shadow-lg" />
            </div>
          </div>
        </div>
      </section>

      {/* Want to show funders lasting workforce impact? Section */}
      <section className="py-8 bg-green-200">
        <div className="container">
          <div className="flex flex-col md:flex-row items-center gap-6">
            <div>
              <h2 className="text-2xl md:text-3xl font-semibold mb-2">
                Want to show funders lasting workforce impact?
              </h2>
              <p className="text-2xl">
                Great fit for: Workforce boards, youth programs, reentry orgs, municipal initiatives
              </p>
            </div>

            <a
              href="https://meetings.hubspot.com/chrissybil/vero-learning"
              className="btn btn-secondary !text-lg hover:underline mt-4 md:mt-0"
              target="_blank"
            >
              Let’s build your data story
              <ExportedIcon style={{ fontSize: 20 }} />
            </a>
          </div>
        </div>
      </section>

      {/* How It Works Section  */}
      <section className="bg-primary-200 py-16">
        <div className="container">
          <div className="text-center mb-10">
            <p className="text-xl mb-4">How It Works</p>
            <h2 className="text-3xl sm:text-4xl md:text-6xl font-light !leading-snug">
              How Vero Transforms Hiring- from Day One to
              <span className="text-primary-500 font-bold"> Day 1000</span>
            </h2>
          </div>

          {/* Cards */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
            {/* Step 1 */}
            <div className="relative bg-white rounded-[40px] p-8 md:p-4  flex flex-col items-center text-center max-h-[470px]">
              <SurfaceIcon className="mb-5" />
              <h3 className="text-2xl font-semibold mb-3">Surface Hidden Potential</h3>
              <p className="text-lg">
                Capture real-world experience, natural competencies, and behavioral signals to
                spotlight who’s ready to grow—beyond what a resume shows.
              </p>
            </div>

            {/* Step 2 */}
            <div className="relative md:mt-[15%]">
              <img
                src={connectingLine}
                alt="connecting Line"
                className="relative -ml-10 hidden md:block"
              />
              <div className="bg-white rounded-[40px] p-8 md:p-4  flex flex-col items-center text-center max-h-[470px]">
                <MatchIcon className="mb-5" />
                <h3 className="text-2xl font-semibold mb-3">Predict What Comes Next</h3>
                <p className="text-lg ">
                  Vero analyzes skills, motivation, fit, and trajectory to match candidates to roles
                  where they’ll thrive—not just today, but long-term.
                </p>
              </div>
            </div>

            {/* Step 3 */}
            <div className="relative md:mt-[50%]">
              <img
                src={connectingLine}
                alt="connecting Line"
                className="relative -ml-10  hidden md:block"
              />
              <div className="bg-white rounded-[40px] p-8 md:p-4 flex flex-col items-center text-center max-h-[470px]">
                <PlaceIcon className="mb-5" />
                <h3 className="text-2xl font-semibold mb-3">Place, Learn, and Elevate</h3>
                <p className="text-lg">
                  Track retention, manager feedback, and career growth outcomes to improve every
                  future match—and fuel mobility from the ground up.
                </p>
              </div>
            </div>
          </div>
          <div className="flex flex-col md:flex-row items-center mt-12  gap-5 text-center">
            <a
              href="https://meetings.hubspot.com/chrissybil/vero-learning"
              className="btn btn-secondary w-fit !text-lg !px-12 !py-6 hover:underline"
              target="_blank"
            >
              See what others miss <ExportedIcon />
            </a>
            <p className="text-xl sm:text-2xl !leading-loose mb-5">
              Smarter hiring starts by seeing what others miss—and helping them rise.
            </p>
          </div>
        </div>
      </section>

      {/* Proven Impact Section */}
      <section className="pt-16">
        <div className="container">
          <h2 className="text-5xl text-center">
            Proven <span className="text-primary-500 font-bold">Impact.</span>
          </h2>
          <TestimonialCarousel testimonials={testimonialData} />
        </div>
      </section>

      {/* #1 Vocational Section */}
      <VovationalPage imagePosition="right" />

      {/* Founder Note Section */}
      <section className="flex items-center justify-center bg-white py-28">
        <div className="container">
          <div className="flex flex-col lg:flex-row items-center justify-between gap-10">
            {/* Image */}
            <div className="flex-shrink-0">
              <img src={founderImg} alt="Chrissybil Boulin" className="rounded-full" />
            </div>

            {/* Text Section */}
            <div className="text-center lg:text-left">
              <p className="text-2xl mb-4">Founder Note</p>
              <h3 className="text-4xl md:text-5xl lg:text-6xl font-light !leading-snug mb-6">
                Built by a founder who knows <span className="font-bold">what others miss</span>
              </h3>
              <p className="text-xl leading-loose">
                Vero was founded by Chrissybil Boulin—a second-time founder who has helped thousands
                of students unlock their potential and save millions on college tuition. Today,
                she’s scaling that belief into an AI platform that sees talent others overlook and
                turns it into long-term success.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* contact us section */}
      <ConnectForm
        header="Let’s shape the future of work-together"
        text="Vero isn’t just built for placement—it’s built for progress. Join the employers and changemakers using Vero to unlock new potential at scale."
        buttonText="Book a conversation"
      />
      <NewFooter />
    </>
  );
};
